<template>

    <!-- About Us Header with Background Image -->
    <section class="about-header text-center mt-0" style="background: url('/images/insidegym8.jpg') no-repeat center center; background-size: cover; padding: 50px 0; color: #fff;">
      <h1 class="display-4 font-weight-bold">GALLERY</h1>
      <!-- <p class="lead">Soldiers Gym aims to bring ‘next-generation fitness’ with top-notch specialized workout facilities and training programs for all members.</p> -->
    </section>

  <div class="gallery-container">
    <p class="text-center lead">Explore some of the highlights from Soldier's Gym.</p>

    <!-- Image Gallery -->
    <div class="gallery-grid">
      <div class="gallery-item">
        <img src="/images/insidegym1.jpg" alt="Gym Photo 5" class="img-fluid" />
      </div>
     
   
      <div class="gallery-item">
        <img src="/images/insidegym8.jpg" alt="Gym Photo 6" class="img-fluid" />
      </div>
      <div class="gallery-item">
        <img src="/images/insidegymcarousel.jpg" alt="Gym Photo 1" class="img-fluid" />
      </div>
      <div class="gallery-item">
        <img src="/images/insidegym6.jpg" alt="Gym Photo 2" class="img-fluid" />
      </div>
      <div class="gallery-item">
        <img src="/images/insidegymcarousel2.jpg" alt="Gym Photo 3" class="img-fluid" />
      </div>
      <div class="gallery-item">
        <img src="/images/insidegymcarousel3.jpg" alt="Gym Photo 4" class="img-fluid" />
      </div>
      <div class="gallery-item">
        <img src="/images/insidegym6.jpg" alt="Gym Photo 6" class="img-fluid" />
      </div>
      <div class="gallery-item">
        <img src="/images/insidegymcarousel5.jpg" alt="Gym Photo 6" class="img-fluid" />
      </div>
      <div class="gallery-item">
        <img src="/images/insidegymcarousel6.jpg" alt="Gym Photo 6" class="img-fluid" />
      </div>
      <div class="gallery-item">
        <img src="/images/insidegym7.jpg" alt="Gym Photo 6" class="img-fluid" />
      </div>
      <div class="gallery-item">
        <img src="/images/insidegymcarousel7.jpg" alt="Gym Photo 6" class="img-fluid" />
      </div>
      <div class="gallery-item">
        <img src="/images/insidegym4.jpg" alt="Gym Photo 2" class="img-fluid" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GalleryPage',
};
</script>

<style scoped>
.about-header h1 {
  font-size: 3rem;
  font-weight: 700;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
}

.about-header p {
  font-size: 1.25rem;
  color: #fff;
}

.about-content img {
  border: 5px solid #f2b705;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
  margin-bottom: 30px;
}

.about-content p {
  font-size: 1.15rem;
  color: #555;
  line-height: 1.8;
  margin-bottom: 20px;
}

/* Gallery Container */
.gallery-container {
  margin: 50px auto;
  max-width: 1200px;
  padding: 0 15px;
}

h2 {
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: #333;
}

p {
  font-size: 1.2rem;
  margin-bottom: 40px;
  color: #555;
}

/* Gallery Grid */
.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
}

/* Individual Gallery Item */
.gallery-item {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

/* Hover Effect for Images */
.gallery-item:hover {
  transform: scale(1.05);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
}

/* Image Styling */
.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.3s ease;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .gallery-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
}

@media (max-width: 480px) {
  h2 {
    font-size: 2rem;
  }

  p {
    font-size: 1rem;
  }
}
</style>
